// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__29kJc","key":"key__hGt_k","value":"value__3D_Fz"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBot/styles/summary.scss
// module id = uBfI
// module chunks = 0